import React, { Suspense, lazy } from 'react';
import Fallback from '../Fallback';

const width = 600;
const height = 200;

export default function LazyDashboardIncentivesChart({__placeholder_html__, ...props}) {
  const DashboardIncentivesChart = lazy(() =>
    import('../../components/dashboard/DashboardIncentivesChart')
  );
  return (
    <Suspense
      fallback={<Fallback __placeholder_html__={__placeholder_html__} />}
    >
      <DashboardIncentivesChart width={width} height={height} {...props} />
    </Suspense>
  );
}
